<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :style="style"
    rounded-lg
    outlined
    single-line
    dense
    label="Pesquisar"
    autofocus
    clearable
    hide-details
    prepend-inner-icon="mdi-magnify"
    @focus="onFocus"
  ></v-text-field>
</template>

<script>
import form_mixin from "./form_mixin";

export default {
  mixins: [form_mixin],
  props: {
    select: {
      type: Boolean,
      default: false
    },

    width: {
      type: String,
      default: '250px'
    },
  },

  computed: {
    style() {
      return {
        maxWidth: this.width,
      } 
    }
  },
  methods: {
    onFocus(event) {
      if (this.select) {
        setTimeout(function () {
          event.target.select();
        }, 0);
      }
    },
  },
};
</script>

<style scoped>
</style>